import {Component, computed, forwardRef, input, signal} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {TranslocoDirective} from '@jsverse/transloco';
import {MatSlider, MatSliderRangeThumb} from '@angular/material/slider';

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrl: './range-slider.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeSliderComponent),
      multi: true,
    },
  ],
  imports: [
    TranslocoDirective,
    MatSlider,
    MatSliderRangeThumb
  ]
})
export class RangeSliderComponent implements ControlValueAccessor {

  type = input.required<RangeSliderType>();
  openMaxInterval = input<boolean>(false);
  monetaryRange = input<boolean>(false);

  title = computed<string>(() => {
    switch (this.type()) {
      case RangeSliderType.LOYALTY: {
        return 'filters.loyaltyScore';
      }
      case RangeSliderType.AMOUNT: {
        return 'filters.amount';
      }
    }
  });

  sliderParams = computed<SliderParams>(() => {
    switch (this.type()) {
      case RangeSliderType.LOYALTY: {
        return {min: 1, max: 10, step: 0.1} as SliderParams
      }
      case RangeSliderType.AMOUNT: {
        return {min: 0, max: 200, step: 1} as SliderParams
      }
    }
  });
  value = signal<NumericRange | undefined>(undefined);
  computedValue = computed<NumericRange>(() => {
    if (this.value()) {
      if(this.value()!.min === undefined) {
        this.value()!.min = this.sliderParams().min;
      }
      if(this.value()!.max === undefined) {
        this.value()!.max = this.openMaxInterval() ? undefined : this.sliderParams().max;
      }
      return this.value()!;
    } else {
      return {
        min: this.sliderParams().min,
        max: this.openMaxInterval() ? undefined : this.sliderParams().max
      };
    }
  });

  onChange = (value: NumericRange) => {
  };
  onTouched = () => {
  };

  writeValue(value: NumericRange): void {
    this.value.set(value);
  }

  registerOnChange(fn: (value: NumericRange) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onMinChange(event: number): void {
    this.value.set({...this.value()!, min: event});
    this.onChange(this.value()!);
  }

  onMaxChange(event: number): void {
    if (this.openMaxInterval() && event === this.sliderParams().max) {
      this.value.set({...this.value()!, max: undefined});
    } else {
      this.value.set({...this.value()!, max: event});
    }
    this.onChange(this.value()!);
  }
}

export enum RangeSliderType {
  LOYALTY = 'LOYALTY',
  AMOUNT = 'AMOUNT',
}

export interface NumericRange {
  min: number;
  max?: number;
}

interface SliderParams {
  min: number;
  max: number;
  step: number;
}
